import React from 'react';

const TimeCard = ({ time }) => {
  return (
    <div className="bg-[var(--background-color-card)] p-6 rounded-xl border border-[var(--color-border-subtle)] shadow-sm" data-testid="timeCard-container">
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-lg font-bold text-[#022B3A] dark:text-[#FFFFFF]">{time.day}, {time.hour}:00</p>
        </div>
      </div>
      <div className="relative">
        <p>Activity Score: {time.activity_score}</p>
        <p className="text-sm text-text-light-secondary dark:text-text-dark-secondary italic border-l-2 border-blue-300 pl-3 my-3">
          {time.recommendation}
        </p>
      </div>
    </div>
  );
};

export default TimeCard;
